import {Box, Text} from '@chakra-ui/react';
import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {useTranslation} from 'react-i18next';
import {ModaleLayout} from '@/components/Modale/ModaleLayout';

// Composant pour afficher une note commerciale dans une modale
// Utilisé pour afficher la note d'un commercial sur un devis
interface ModaleNoteCommercialProps {
  note: string;
}

export const ModaleNoteCommercial = NiceModal.create<ModaleNoteCommercialProps>(
  ({note}) => {
    const modal = useModal();
    const {t} = useTranslation();

    return (
      <ModaleLayout
        visible={modal.visible}
        hide={modal.remove}
        titre={t('liste.devis_personnalise.note_commercial')}
      >
        <Box p={4}>
          <Text
            fontSize='md'
            color='gray.dark'
            whiteSpace='pre-wrap'
            fontStyle='italic'
          >
            &quot;{note}&quot;
          </Text>
        </Box>
      </ModaleLayout>
    );
  },
);
